import markdownIt from "markdown-it";
// @ts-ignore — no types
import mdIns from "markdown-it-ins";
// @ts-ignore — no types
import mdSub from "markdown-it-sub";
// @ts-ignore — no types
import mdSup from "markdown-it-sup";
import { useMemo } from "react";
import rules from "./rules";

/**
 * Returns a markdown-it parser configured for the given variant.
 */
export const useMarkdownIt = (variant: keyof typeof rules) =>
	useMemo(() => {
		const { config, disabled } = rules[variant];
		return markdownIt(config)
			.use(mdSup)
			.use(mdSub)
			.use(mdIns)
			.disable(disabled);
	}, [variant]);
